import { useQuery } from '@tanstack/react-query'
import { supportService } from '@/services/api/supportService'
import type { GuidanceSurface } from '@/lib/guidanceSurfaces'

/**
 * Fetches the published guidance video bound to a page/dialog surface (or null).
 * Cached for 5 min; powers <VideoHelpButton>, which hides itself when there's no
 * video for the surface.
 */
export function useGuidanceVideo(surface: GuidanceSurface) {
  return useQuery({
    queryKey: ['guidance-video', surface],
    queryFn: () => supportService.getTrainingMaterialBySurface(surface),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    retry: false,
  })
}
